const landingTypesList = [
  '/',
  '/fullPrice',
  '/option_b',
  '/option_c',
  '/option_b2',
  '/latam',
  '/discountb',
  '/trial',
  '/promo',
];

export default landingTypesList;
